import { SettingsService } from "@/services/settings-service"

/**
 * Return the indexes available for a given session type — i.e. those not
 * blocked via `blocked_modules`.
 *
 * Shared by the navigator store, `useLibrariesSelection`, and the
 * project-settings "pinned libraries" picker so the filter rule stays in one
 * place. If the rule ever grows another condition (tenant/language/etc.),
 * update it here.
 */
export function getAvailableIndexesForSession(sessionType: string) {
  const settingsService = SettingsService.getInstance()
  return settingsService.settings.indexes.filter((index) => {
    if (!index.blocked_modules || index.blocked_modules.length === 0) {
      return true
    }
    return !index.blocked_modules.includes(sessionType)
  })
}
